import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import desiriUserService from "../../services/desiriUser/userservice";
import DesiriUserSearch from "./desiri-user-search";
import DesiriUserTable from "./desiri-user-table";
import { BreadCrumb } from "primereact/breadcrumb";
const DesiriUserPage: React.FC = () => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<any[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText, users]);

  const fetchUsers = async () => {
    try {
      const [users, designations, muPlants] = await Promise.all([
        desiriUserService.getAllUsers(),
        desiriUserService.getAllDesignations(),
        desiriUserService.getAllMUPlants(),
      ]);

      const mappedUsers = users.map((user: any) => {
        const designation = designations.find(
          (d: any) => d.id === user.designationID
        );
        const pos = muPlants.find((m: any) => m.posID === user.posID);

        return {
          ...user,
          designationName: designation?.name || "",
          posName: pos?.posName || "",
        };
      });
      setUsers(mappedUsers);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };
  const breadcrumbItems = [
    { label: "Desiri Master Data", url: "" },
    { label: "Desiri User Profiles", url: "" },
  ];
  const home = { icon: "pi pi-home", url: "/" };

  const handleSearch = (text: string) => {
    const terms = text.toLowerCase().trim().split(/\s+/);
    const filtered = users.filter((u) => {
      const line = Object.values(u).join(" ").toLowerCase();
      return terms.every((term) => line.includes(term));
    });
    setFilteredUsers(filtered);
  };

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <div className="col-12">
        <h4 className="ml-1 mb-1">{t("Desiri User Profile")}</h4>
      </div>

      {/* <BreadCrumb
        model={breadcrumbItems}
        home={home}
        className=" mb-2 bg-transparent px-0 py-0 text-sm  text-gray-600"
        style={{
          border: "none",
          boxShadow: "none",
          background: "transparent",
          marginLeft: "11px",
        }}
      /> */}
      <DesiriUserSearch onSearch={setSearchText} onRefresh={fetchUsers} />
      <DesiriUserTable data={filteredUsers} onRefresh={fetchUsers} />
    </div>
  );
};

export default DesiriUserPage;
